import { render } from "./Second.vue?vue&type=template&id=66aa09ca&scoped=true"
import script from "./Second.vue?vue&type=script&lang=js"
export * from "./Second.vue?vue&type=script&lang=js"

import "./Second.vue?vue&type=style&index=0&id=66aa09ca&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66aa09ca"]])

export default __exports__